"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _LicenseTcDetails = _interopRequireDefault(require("./components/LicenseTcDetails.vue"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    LicenseTcDetail: _LicenseTcDetails.default
  }
})], default_1);
var _default = exports.default = default_1;